import Axios from "../config/Axios";
import {actions} from '../reducers/jira';

export const fetchUsers = () => {
  
    return {
        type: actions.FETCH_ALL_JIRA_USERS,
        payload: Axios.instanceV2.get('user/all')
    }
};



// WEBPACK FOOTER //
// ./app/actions/jiraActions.ts